import { createFileRoute } from '@tanstack/react-router';

import { buildSeoHead, ROUTE_META } from '@src/corelib/seo';
import { DefaultLayout } from '@src/layout';
import Security from '@src/pages/Security';

export const Route = createFileRoute('/security')({
  head: () => buildSeoHead({ path: '/security', ...ROUTE_META['/security'] }),
  component: SecurityPageWithLayout,
});

function SecurityPageWithLayout() {
  return (
    <DefaultLayout>
      <Security />
    </DefaultLayout>
  );
}
